import type { SelectProps } from "@mantine/core"

type SelectComboboxProps = NonNullable<SelectProps["comboboxProps"]>

export const selectComboboxDefaults: SelectComboboxProps = {
    position: "bottom",
    middlewares: {
        flip: true,
        shift: true,
    },
    offset: 4,
}

export const mergeSelectComboboxProps = (
    overrides?: SelectProps["comboboxProps"],
): SelectComboboxProps => ({
    ...selectComboboxDefaults,
    ...overrides,
    middlewares: {
        ...selectComboboxDefaults.middlewares,
        ...overrides?.middlewares,
    },
})
